import store from "../store"
import Vue from "vue";

Vue.directive("access", {
	bind: function (el, binding, vnode) {
		el.setAttribute('ods', el.style.display)
		el.style.display = 'none';
	},
	inserted(el, binding) {
		let value = binding.value

		let unwatch = function () {

		}
		const handler = (permissions) => {
			if (!permissions) {
				permissions = [];
			}
			if (permissions.length > 0 && binding.arg === 'can' && array_intersection(permissions, value).length > 0) {// && permissions.includes(value)) {
				el.style.display = el.getAttribute('ods');
			} else if (permissions.length > 0) {
				el.parentNode.removeChild(el)
				unwatch()
			}
		}

		handler(store.state.user.permissions)
		unwatch = store.watch(() => store.state.user.permissions, handler)
		el.__can__unwatch = unwatch
	},

	unbind() {
		// el && el.__can__unwatch && el.__can__unwatch()
	}
});
function array_intersection(arr1, arr2){

	return arr1.filter(function(x) {
		return (arr2.indexOf(x) !== -1)
	});
}



export const access = {
};
export default access;
